import { useRiskMonitoringStore } from '@/store/riskMonitoring.store.js';
import { useTenantStore } from '@/store/tenant.store.js';

export class RiskMonitoringIntegration {
    constructor(sdkService) {
        this.service = sdkService;
        this._inflight = null;
        this._tenantScope = null;
        this._pendingSections = new Set();
        this._flushScheduled = false;
    }

    /**
     * Widget provider entry point: concurrent widget mounts share one request.
     * A tenant switch invalidates the in-flight guard.
     */
    ensureData(sections = []) {
        const tenantScope = String(useTenantStore.getState().selectedTenantId ?? '');
        if (this._tenantScope !== tenantScope) {
            this._tenantScope = tenantScope;
            this._inflight = null;
            this._pendingSections.clear();
        }
        for (const section of sections) this._pendingSections.add(section);
        if (this._flushScheduled) return this._inflight;
        this._flushScheduled = true;
        queueMicrotask(() => {
            this._flushScheduled = false;
            const batch = [...this._pendingSections];
            this._pendingSections.clear();
            if (this._inflight) return;
            this._inflight = this.fetchData(batch).finally(() => {
                this._inflight = null;
                if (this._pendingSections.size > 0) this.ensureData();
            });
        });
        return this._inflight;
    }

    async fetchData(sections = []) {
        const store = useRiskMonitoringStore.getState();
        store.setLoading(true);
        store.setError(null);
        try {
            const result = await this.service.getMonitoring(
                sections.length > 0 ? { sections: sections.join(',') } : {}
            );
            const body = result?.data;
            const payload =
                body && typeof body === 'object' && 'data' in body && body.data !== undefined && body.data !== null
                    ? body.data
                    : body;

            useRiskMonitoringStore.setState((state) => ({
                data: { ...(state.data || {}), ...(payload || {}) },
                loading: false,
                lastUpdated: new Date().toISOString(),
            }));
        } catch (error) {
            useRiskMonitoringStore.setState({
                error: error.message,
                loading: false,
            });
        }
    }
}
